import { Select, type SelectProps } from '@/components/presentation/Select';
import { TranscriptPublishType, TranscriptPublishType_utils } from '@/enums';

type Props = {
  value: TranscriptPublishType;
} & Pick<SelectProps<Record<TranscriptPublishType, string>, TranscriptPublishType>, 'disabled' | 'onChange'>;

export const PublishSettingsSelect = (props: Props) => {
  return (
    <Select
      defaultValue={TranscriptPublishType.RecordingOnly}
      disabled={props.disabled}
      onChange={props.onChange}
      options={Options}
      value={props.value} />
  );
};

PublishSettingsSelect.displayName = 'PublishSettings.Select';

const Options = TranscriptPublishType_utils.values().reduce((acc, id) => ({
  ...acc,
  [id]: TranscriptPublishType_utils.getName(id),
}), {} as Record<TranscriptPublishType, string>);